/* =============================================================================
   MATKARTELLET — SPISKAMMERET (v2)
   Built from Tor's reference photograph rather than from the first sketch.

   What changed, and why each one matters more than it sounds:
     · the vault is lime-washed white, not exposed brick. A white segmental
       vault is a reflector — it takes one warm lantern and spreads it over the
       whole room, which is the entire reason the reference photo feels like a
       place rather than a tunnel.
     · the shelves are thick open pine planks on standing posts. No side
       panels, no back boards: you see through them to the plaster, and the
       goods sit in light instead of in a box.
     · the floor is dark terracotta tile, which is what stops a bright room
       from floating.
     · the far wall is no longer a way out. It holds two speakers and a
       turntable, so the end of the walk is somewhere to stay.
     · nothing hangs from the crown. Sausages strung from the vault read as
       clutter overhead and pull the eye off the shelves; the dried sausage
       now lives only in the crates where it belongs.
   ========================================================================== */
(function () {
'use strict';
var K = window.SceneKit, ROOT = document.getElementById('cs-root');
if (!ROOT) return;
var PI = Math.PI, TAU = PI * 2;

/* Settings the merchant controls from the theme editor. The section prints
   them as JSON; everything here has a sane default so the file still runs
   standalone, outside Shopify, with no config tag present at all. */
var CFG = {};
try {
  var cfgEl = document.getElementById('cs-scene-config');
  if (cfgEl) CFG = JSON.parse(cfgEl.textContent) || {};
} catch (e) { CFG = {}; }
var cfg = function (k, d) { return (CFG[k] === undefined || CFG[k] === null) ? d : CFG[k]; };

/* ── the shots ─────────────────────────────────────────────────────────── */
var CAM = [
  { p: [  0.00, 1.58,  4.80 ], t: [ 0.0, 1.44,  -9.4 ], fov: 50 },  /* 0 the room     */
  { p: [ -0.55, 1.32,  2.20 ], t: [-2.9, 1.24,  -1.2 ], fov: 56 },  /* 1 left shelves */
  { p: [  0.55, 1.26, -1.20 ], t: [ 2.9, 1.44,  -5.0 ], fov: 52 },  /* 2 right shelves*/
  { p: [ -0.40, 1.05, -4.20 ], t: [-1.6, 1.54,  -8.2 ], fov: 54 },  /* 3 low, the corner */
  { p: [  0.00, 1.32, -8.00 ], t: [ 0.0, 0.96, -11.4 ], fov: 44 },  /* 4 the hi-fi    */
  { p: [  0.00, 1.06, -9.60 ], t: [ 0.0, 0.72, -11.2 ], fov: 40 }   /* 5 the record   */
];

/* ── the room ──────────────────────────────────────────────────────────── */
/* A segmental vault, not a semicircle: 4.7 m across with only 0.95 m of rise,
   which is what gives the reference room its low, held-in feeling. Everything
   else follows from those two numbers. */
var R = { halfW: 2.70, spring: 2.05, rise: 1.00, zEnd: -11.2, zBack: 18 };
R.vaultR = (R.halfW * 2 * (R.halfW * 2) / (8 * R.rise)) + R.rise / 2;
R.vaultY = R.spring - (R.vaultR - R.rise);          /* centre of the arc      */
R.half   = Math.asin(R.halfW / R.vaultR);           /* half the swept angle   */
R.apex   = R.spring + R.rise;
R.shelfD = .55; R.shelfX = R.halfW - R.shelfD / 2;
R.levels = [.62, 1.16, 1.70];
R.zFrontShelf = 5.4; R.zBackShelf = -9.6;

var C = { ink: 0x14100c, lamp: 0xffb877, accent: 0xffc287, sky: 0xb59a7c, ground: 0x2a1d14 };

var renderer, scene, camera, world, composer, rig, page, dust, glow;
var M = {}, LAMPS = [], elapsed = 0, lastT = 0, ready = false;
var vpW = function () { return Math.max(1, ROOT.clientWidth || innerWidth); };
var vpH = function () { return Math.max(1, innerHeight); };

/* ── palettes (sRGB in, linear out) ────────────────────────────────────── */
var ONION   = [K.lin(0x9c4a2a), K.lin(0xb4632f), K.lin(0x86381f), K.lin(0xc98a4a)];
var GARLIC  = [K.lin(0xe4dcc8), K.lin(0xd8ccb2), K.lin(0xefe8d8)];
var PRESERVE= [K.lin(0x8a9c62), K.lin(0xa8783a), K.lin(0x6f4a2a), K.lin(0xb4462a), K.lin(0x5f6d4c)];
var WINE    = [K.lin(0x2c3a24), K.lin(0x24301e), K.lin(0x3a2a1c), K.lin(0x1e2a2c)];
var VEG     = [K.lin(0xc26a1e), K.lin(0x8c9a4e), K.lin(0xb8321f), K.lin(0xd9b322)];

/* ── a floor the reference room actually has ───────────────────────────── */
/* Dark terracotta squares with a worn diamond motif. Written here rather than
   taken from the kit because the kit's flagstone is a grey European street and
   this is a warm Mediterranean pantry — the floor is half the room's colour. */
function bakeTerracotta(seed) {
  var W = 1024, H = 1024;
  var c = K.cvs(W, H), x = c.getContext('2d');
  var h = K.cvs(W, H), hx = h.getContext('2d');
  var r0 = K.rng(seed), n = K.noise2D(seed + 11), i, j;
  x.fillStyle = K.rgb(34, 25, 21); x.fillRect(0, 0, W, H);      /* grout */
  hx.fillStyle = '#3c3c3c'; hx.fillRect(0, 0, W, H);
  var N = 5, S = W / N, g = 5;
  for (j = 0; j < N; j++) for (i = 0; i < N; i++) {
    var tx = i * S + g, ty = j * S + g, tw = S - g * 2, t = .78 + r0() * .5;
    x.fillStyle = K.rgb(84 * t, 50 * t, 40 * t);
    x.fillRect(tx, ty, tw, tw);
    hx.fillStyle = K.rgb(150 + t * 70, 150 + t * 70, 150 + t * 70);
    hx.fillRect(tx, ty, tw, tw);
    /* the motif: a faint inscribed diamond, worn off some tiles entirely */
    if (r0() > .30) {
      x.save();
      x.globalAlpha = .10 + r0() * .16;
      x.strokeStyle = K.rgb(28, 20, 16); x.lineWidth = 2.2 + r0() * 2;
      x.translate(tx + tw / 2, ty + tw / 2); x.rotate(PI / 4);
      var d = tw * (.26 + r0() * .08);
      x.strokeRect(-d, -d, d * 2, d * 2);
      x.beginPath(); x.arc(0, 0, tw * .07, 0, TAU); x.stroke();
      x.restore();
    }
    /* the chipped arris every old tile floor has */
    var k;
    for (k = 0; k < 3; k++) {
      if (r0() > .7) {
        x.fillStyle = K.rgb(40, 29, 24);
        x.fillRect(tx + r0() * tw * .8, ty + (r0() > .5 ? 0 : tw - 4), 4 + r0() * 12, 4);
      }
    }
  }
  /* wear: the middle of the room is walked, the edges are not */
  var im = x.getImageData(0, 0, W, H), d2 = im.data, px, py, v, kk;
  for (py = 0; py < H; py++) for (px = 0; px < W; px++) {
    kk = (py * W + px) * 4;
    v = 1 + K.fbm(n, px / 90, py / 90, 3, 2.1, .5) * .30 + (r0() - .5) * .06;
    d2[kk] *= v; d2[kk + 1] *= v; d2[kk + 2] *= v;
  }
  x.putImageData(im, 0, 0);
  return { map: K.toTex(c, 1, 1, true),
           normalMap: K.toTex(K.normalFromHeight(h, 2.2)), roughnessMap: null };
}

/* ── props ─────────────────────────────────────────────────────────────── */
function jar(B, x, y, z, r, hh, rnd) {
  var col = PRESERVE[(rnd() * PRESERVE.length) | 0];
  B.add(K.gCyl(r * .93, r, hh, 12), 'glass', K.place(x, y + hh / 2, z), col);
  B.add(K.gCyl(r * 1.02, r * 1.02, hh * .38, 12), 'label', K.place(x, y + hh * .44, z));
  B.add(K.gCyl(r * .62, r * .86, hh * .14, 12), 'glass', K.place(x, y + hh + hh * .05, z), col);
  B.add(K.gCyl(r * .68, r * .68, .045, 12), 'lid', K.place(x, y + hh + hh * .12, z));
}
function bottle(B, x, y, z, r, hh, rnd, key) {
  var col = (key === 'wine' ? WINE : PRESERVE)[(rnd() * 4) | 0];
  B.add(K.gCyl(r, r, hh * .60, 12), 'glass', K.place(x, y + hh * .30, z), col);
  B.add(K.gCyl(r * .28, r, hh * .20, 12), 'glass', K.place(x, y + hh * .70, z), col);
  B.add(K.gCyl(r * .26, r * .26, hh * .22, 10), 'glass', K.place(x, y + hh * .91, z), col);
  B.add(K.gCyl(r * .31, r * .31, hh * .09, 10), 'foil', K.place(x, y + hh * 1.0, z));
  B.add(K.gCyl(r * 1.02, r * 1.02, hh * .22, 12), 'label', K.place(x, y + hh * .32, z));
}
/* wine laid on its side, stacked the way it is on a cellar shelf */
function wineStack(B, s, y, z, rows, rnd) {
  var r = .039, L = .30, i, j;
  for (j = 0; j < rows; j++) {
    var n = 4 - j;
    for (i = 0; i < n; i++) {
      var bx = s * (R.shelfX - .06) + 0, bz = z - (n - 1) * .05 + i * .10;
      var by = y + r + j * (r * 1.85);
      B.add(K.gCyl(r, r, L, 10), 'glass',
            K.place(bx, by, bz, 0, 0, PI / 2), WINE[(rnd() * WINE.length) | 0]);
      B.add(K.gCyl(r * .30, r * .30, .10, 8), 'glass',
            K.place(bx - s * (L / 2 + .05), by, bz, 0, 0, PI / 2), WINE[0]);
    }
  }
}
/* a net of onions: the pile plus a warm translucent skin over it, which is all
   a mesh sack really is at this distance */
function onionNet(B, x, y, z, w, rnd) {
  var n = 12 + ((rnd() * 8) | 0), i;
  for (i = 0; i < n; i++) {
    var rr = .045 + rnd() * .028;
    B.add(K.gSph(1, 9), 'produce',
          K.place(x + (rnd() - .5) * w, y + rr + rnd() * .09, z + (rnd() - .5) * .30,
                  rnd() * PI, rnd() * PI, 0, rr, rr * .88, rr),
          ONION[(rnd() * ONION.length) | 0]);
  }
  B.add(K.gSph(1, 10), 'net',
        K.place(x, y + .10, z, 0, 0, 0, w * .58, .12, .20), ONION[1]);
}
function garlicRow(B, x, y, z, n, rnd) {
  for (var i = 0; i < n; i++) {
    var rr = .038 + rnd() * .014;
    B.add(K.gSph(1, 9), 'produce',
          K.place(x + (rnd() - .5) * .16, y + rr, z - n * .05 + i * .10,
                  0, rnd() * PI, 0, rr, rr * .82, rr),
          GARLIC[(rnd() * GARLIC.length) | 0]);
  }
}
function pumpkin(B, x, y, z, r) {
  B.add(K.gSph(1, 14), 'produce', K.place(x, y + r * .72, z, 0, 0, 0, r, r * .74, r),
        VEG[0]);
  B.add(K.gCyl(.022, .030, .075, 8), 'stem', K.place(x, y + r * 1.42, z));
}
function basket(B, x, y, z, r, hh, rnd) {
  var i;
  B.add(K.gCyl(r * .74, r * .74, .035, 14), 'wicker', K.place(x, y + .018, z));
  for (i = 0; i < 4; i++) {
    var t = i / 3, rr = r * (.76 + t * .30);
    B.add(K.gCyl(rr, rr, hh * .23, 14), 'wicker', K.place(x, y + .04 + t * hh * .80 + hh * .11, z));
  }
  if (rnd() > .4) for (i = 0; i < 7; i++) {
    var vr = .04 + rnd() * .03;
    B.add(K.gSph(1, 9), 'produce',
          K.place(x + (rnd() - .5) * r, y + hh * .82 + vr, z + (rnd() - .5) * r,
                  0, rnd() * PI, 0, vr, vr * .9, vr),
          VEG[(rnd() * VEG.length) | 0]);
  }
}
/* a shallow crate of dried sausage, as in the photograph */
function sausageCrate(B, x, y, z, rnd) {
  var w = .62, d = .40, i;
  B.add(K.gBox(d, .05, w), 'shelf', K.place(x, y + .025, z));
  B.add(K.gBox(d, .13, .04), 'shelf', K.place(x, y + .09, z + w / 2));
  B.add(K.gBox(d, .13, .04), 'shelf', K.place(x, y + .09, z - w / 2));
  B.add(K.gBox(.04, .13, w), 'shelf', K.place(x + d / 2, y + .09, z));
  B.add(K.gBox(.04, .13, w), 'shelf', K.place(x - d / 2, y + .09, z));
  for (i = 0; i < 7 + ((rnd() * 5) | 0); i++) {
    var rr = .026 + rnd() * .012, L = .16 + rnd() * .10;
    B.add(K.gCyl(rr, rr, L, 8), 'meat',
          K.place(x + (rnd() - .5) * (d - .10), y + .06 + rr, z + (rnd() - .5) * (w - .16),
                  0, rnd() * PI, PI / 2),
          K.lin(0x5a2620));
  }
}
function board(B, s, y, z, rnd) {
  /* chopping boards leaning against the plaster */
  var w = .26 + rnd() * .10, hh = .38 + rnd() * .12;
  B.add(K.gBox(.022, hh, w), 'oak',
        K.place(s * (R.halfW - .09), y + hh / 2, z, 0, 0, s * .10));
  B.add(K.gCyl(.030, .030, .022, 10), 'oak',
        K.place(s * (R.halfW - .09), y + hh - .05, z, 0, 0, PI / 2));
}
function sack(B, x, y, z, r, hh, rnd) {
  B.add(K.gCyl(r * .80, r, hh, 12), 'sackcloth', K.place(x, y + hh / 2, z, 0, rnd() * TAU, 0));
  B.add(K.gSph(1, 10), 'sackcloth', K.place(x, y + hh - .02, z, 0, 0, 0, r * .82, r * .32, r * .82));
  B.add(K.gCyl(r * .26, r * .38, .18, 10), 'sackcloth', K.place(x, y + hh + .10, z));
}

/* ── the shell ─────────────────────────────────────────────────────────── */
function buildShell(B) {
  var len = R.zBack - R.zEnd, cz = (R.zBack + R.zEnd) / 2, i, s;

  B.add(K.gBox(R.halfW * 2 + 3, .5, len + 4), 'floor', K.place(0, -.25, cz));

  /* the side walls, up to the springing line */
  for (s = -1; s <= 1; s += 2) {
    B.add(K.gBox(.5, R.spring + .1, len + 3), 'plaster',
          K.place(s * (R.halfW + .25), (R.spring + .1) / 2, cz));
  }

  /* the vault, swept as eighteen plastered strips about a centre below the
     floor. Faceting a segmental arch this shallow is invisible once it is
     lime-washed, and it keeps the whole ceiling in one merged buffer. */
  var N = 18, span = R.half * 2, chord = 2 * R.vaultR * Math.sin(span / (2 * N)) * 1.06;
  for (i = 0; i < N; i++) {
    var th = (PI / 2 - R.half) + (i + .5) / N * span;
    B.add(K.gBox(chord, .30, len + 3), 'plaster',
          K.place(Math.cos(th) * (R.vaultR + .15), R.vaultY + Math.sin(th) * (R.vaultR + .15),
                  cz, 0, 0, th - PI / 2));
  }

  /* the end wall, and the lunette the vault leaves above it */
  B.add(K.gBox(R.halfW * 2 + 1, R.spring + .1, .5), 'plaster',
        K.place(0, (R.spring + .1) / 2, R.zEnd - .25));
  var N2 = 48, chord2 = 2 * R.vaultR * Math.sin(span / (2 * N2)) * 1.10;
  for (i = 0; i < N2; i++) {
    var th2 = (PI / 2 - R.half) + (i + .5) / N2 * span;
    var yy = R.vaultY + Math.sin(th2) * R.vaultR;
    if (yy <= R.spring) continue;
    B.add(K.gBox(chord2, yy - R.spring, .4),
          'plaster', K.place(Math.cos(th2) * R.vaultR, (yy + R.spring) / 2, R.zEnd - .2));
  }
  /* the near wall, well behind the opening shot so the dolly has room */
  B.add(K.gBox(R.halfW * 2 + 1, R.apex + .2, .5), 'plaster',
        K.place(0, (R.apex + .2) / 2, R.zBack));

  /* two rush mats on the tile, exactly as in the photograph */
  B.add(K.gBox(1.25, .022, 1.9), 'mat', K.place(-.10, .011, 1.1, 0, .04, 0));
  B.add(K.gBox(1.15, .022, 1.5), 'mat', K.place(.15, .011, -3.6, 0, -.03, 0));
}

/* ── the shelving ──────────────────────────────────────────────────────── */
/* Open plank shelves on standing posts: no side panels and no back boards, so
   the plaster shows through and everything on them is lit from three sides.
   That openness is most of why the reference room looks generous. */
function buildShelves(B) {
  var s, i, k, zFrom = R.zFrontShelf, zTo = R.zBackShelf, run = zFrom - zTo;
  for (s = -1; s <= 1; s += 2) {
    var x = s * R.shelfX;
    for (k = 0; k < R.levels.length; k++) {
      B.add(K.gBox(R.shelfD, .062, run), 'shelf', K.place(x, R.levels[k], zTo + run / 2));
      /* a slim front lip, which is what catches the lamp and draws the line */
      B.add(K.gBox(.030, .085, run), 'shelf',
            K.place(x - s * (R.shelfD / 2 - .02), R.levels[k] + .01, zTo + run / 2));
    }
    var posts = Math.round(run / 1.75);
    for (i = 0; i <= posts; i++) {
      var pz = zTo + (i / posts) * run;
      B.add(K.gBox(.10, R.levels[2] + .12, .10), 'shelf',
            K.place(x - s * (R.shelfD / 2 - .07), (R.levels[2] + .12) / 2, pz));
      B.add(K.gBox(.08, R.levels[2] + .12, .08), 'shelf',
            K.place(x + s * (R.shelfD / 2 - .06), (R.levels[2] + .12) / 2, pz));
      for (k = 0; k < R.levels.length; k++) {
        B.add(K.gBox(R.shelfD - .04, .07, .09), 'shelf',
              K.place(x, R.levels[k] - .062, pz));
      }
    }
  }
}

/* what stands on them — left is the dry store, right is the bottles */
function dressShelves(B) {
  var s, i, k, rnd, z;
  for (s = -1; s <= 1; s += 2) {
    for (k = 0; k < R.levels.length; k++) {
      var y = R.levels[k] + .031;
      var slots = Math.floor((R.zFrontShelf - R.zBackShelf) / 1.05);
      for (i = 0; i < slots; i++) {
        z = R.zFrontShelf - .5 - i * 1.05;
        if (z < R.zBackShelf + .4) break;
        rnd = K.rng(9000 + i * 41 + k * 7 + (s > 0 ? 733 : 0));
        var x = s * R.shelfX, pick = rnd();

        if (s < 0) {                                   /* — the dry store — */
          if (k === 0 && pick < .40)      onionNet(B, x, y, z, R.shelfD * .7, rnd);
          else if (k === 0)               sausageCrate(B, x, y, z, rnd);
          else if (pick < .30)            garlicRow(B, x, y, z, 5 + ((rnd() * 4) | 0), rnd);
          else if (pick < .62) {
            for (var q = 0; q < 4 + ((rnd() * 3) | 0); q++)
              jar(B, x + (rnd() - .5) * .28, y, z - .35 + q * .19, .062 + rnd() * .022,
                  .15 + rnd() * .07, rnd);
          }
          else if (pick < .80)            onionNet(B, x, y, z, R.shelfD * .66, rnd);
          else                            pumpkin(B, x, y, z, .16 + rnd() * .05);
        } else {                                       /* — the bottles —   */
          if (k === 2 || pick < .42) {
            for (var w = 0; w < 5 + ((rnd() * 3) | 0); w++)
              bottle(B, x + (rnd() - .5) * .22, y, z - .40 + w * .17,
                     .040 + rnd() * .010, .29 + rnd() * .05, rnd, 'wine');
          } else if (pick < .62)          wineStack(B, s, y, z, 2 + ((rnd() * 2) | 0), rnd);
          else if (pick < .84) {
            for (var j = 0; j < 4 + ((rnd() * 3) | 0); j++)
              jar(B, x + (rnd() - .5) * .26, y, z - .32 + j * .18, .070 + rnd() * .026,
                  .17 + rnd() * .08, rnd);
          } else {
            /* glassware: decanters and a couple of stems */
            for (var g = 0; g < 3; g++) {
              B.add(K.gSph(1, 12), 'crystal',
                    K.place(x + (rnd() - .5) * .2, y + .09, z - .2 + g * .2, 0, 0, 0, .075, .085, .075));
              B.add(K.gCyl(.024, .034, .10, 10), 'crystal',
                    K.place(x + (rnd() - .5) * .2, y + .21, z - .2 + g * .2));
            }
          }
        }
      }
    }
    /* the floor line: baskets, sacks, crates and a leaning board or two */
    for (i = 0; i < 9; i++) {
      z = R.zFrontShelf - 1.2 - i * 1.5;
      if (z < R.zBackShelf + .6) break;
      rnd = K.rng(4400 + i * 23 + (s > 0 ? 91 : 0));
      var fx = s * (R.halfW - .38);
      var pick2 = rnd();
      if (pick2 < .34)      basket(B, fx, .02, z, .20 + rnd() * .07, .26, rnd);
      else if (pick2 < .58) sack(B, fx, 0, z, .22 + rnd() * .06, .34 + rnd() * .10, rnd);
      else if (pick2 < .78) sausageCrate(B, fx, .02, z, rnd);
      if (rnd() > .68) board(B, s, R.levels[1] + .04, z + .4, rnd);
    }
  }
  /* The crown stays empty on purpose. Sausages used to hang from it here; they
     sat directly under the lantern, caught the most light in the room and drew
     the eye up and away from the goods. The vault reads better bare. */
}

/* ── the far wall: two speakers and a record player ────────────────────── */
/* This is the reason the walk ends here rather than at a door. A pantry is a
   room you fetch things from; a pantry with a turntable in it is a room you
   stay in, which is a much better last frame for a shop that wants you to
   think of food as something you spend an evening on. */
function speaker(B, x, z) {
  var pl = .022, hh = 1.00, w = .19, d = .26;
  /* A pale cabinet reads as a pillar from the far end of the room. Dark, with
     one warm cap tying it to the shelving, reads as a speaker immediately. */
  B.add(K.gBox(w + .06, pl, d + .05), 'graphite', K.place(x, pl / 2, z));
  /* a shadow gap under the cabinet is what makes a plain box look designed */
  B.add(K.gBox(w - .06, .026, d - .06), 'graphite', K.place(x, pl + .013, z));
  B.add(K.gBox(w, hh, d), 'cabinet', K.place(x, pl + .026 + hh / 2, z));
  B.add(K.gBox(w - .022, hh - .10, .012), 'fabric',
        K.place(x, pl + .026 + hh / 2, z + d / 2 + .004));
  B.add(K.gBox(w + .016, .022, d + .016), 'oakPale', K.place(x, pl + .026 + hh + .011, z));
  B.add(K.gCyl(.005, .005, .004, 10), 'alu', K.place(x, pl + .026 + hh - .09, z + d / 2 + .007));
}
function turntable(B, x, y, z) {
  var i;
  B.add(K.gBox(.44, .052, .35), 'graphite', K.place(x, y + .026, z));
  for (i = 0; i < 4; i++) {
    B.add(K.gCyl(.017, .017, .016, 10), 'graphite',
          K.place(x + (i & 1 ? .18 : -.18), y - .006, z + (i & 2 ? .14 : -.14)));
  }
  B.add(K.gCyl(.152, .152, .020, 26), 'alu', K.place(x - .04, y + .062, z));
  B.add(K.gCyl(.150, .150, .0035, 26), 'vinyl', K.place(x - .04, y + .074, z));
  B.add(K.gCyl(.052, .052, .0040, 20), 'sleeve', K.place(x - .04, y + .0765, z));
  B.add(K.gCyl(.0045, .0045, .022, 8), 'alu', K.place(x - .04, y + .085, z));
  /* the arm: a base at the back corner and a straight tube reaching in */
  B.add(K.gCyl(.026, .030, .040, 12), 'graphite', K.place(x + .165, y + .072, z - .115));
  B.add(K.gCyl(.020, .020, .028, 10), 'alu', K.place(x + .165, y + .100, z - .115));
  B.add(K.gBox(.009, .009, .285), 'alu',
        K.place(x + .085, y + .098, z - .035, 0, -.72, 0));
  B.add(K.gCyl(.019, .019, .026, 10), 'graphite',
        K.place(x + .245, y + .098, z - .175, 0, 0, PI / 2));
  B.add(K.gBox(.016, .010, .020), 'graphite', K.place(x - .095, y + .088, z + .095, 0, -.72, 0));
  for (i = 0; i < 2; i++) {
    B.add(K.gCyl(.016, .016, .012, 12), 'alu', K.place(x - .175, y + .058, z + .10 - i * .085));
  }
}
function hifiWall(B) {
  var z0 = R.zEnd + .52, rnd = K.rng(31), i;

  speaker(B, -1.12, z0 + .04);
  speaker(B,  1.12, z0 + .04);

  /* the console: the same pine as the shelves, so it belongs to the room */
  var cy = .60, cw = 1.56, cd = .42;
  B.add(K.gBox(cw + .07, .045, cd + .04), 'shelf', K.place(0, cy + .022, z0));
  B.add(K.gBox(cw, .40, cd), 'shelf', K.place(0, cy - .20, z0));
  for (i = 0; i < 4; i++) {
    B.add(K.gBox(.045, .18, .045), 'graphite',
          K.place((i & 1 ? .69 : -.69), .09, z0 + (i & 2 ? .16 : -.16)));
  }
  /* records filed in it, and a couple leaning against the side */
  for (i = 0; i < 26; i++) {
    B.add(K.gBox(.011, .305, .305), 'sleeve',
          K.place(-.62 + i * .048 + (rnd() - .5) * .006, cy - .20, z0, 0, (rnd() - .5) * .06, 0),
          [.06 + rnd() * .5, .05 + rnd() * .42, .04 + rnd() * .36]);
  }
  for (i = 0; i < 3; i++) {
    B.add(K.gBox(.013, .315, .315), 'sleeve',
          K.place(.92 + i * .016, .165, z0 + .06, 0, .12, -.17),
          [.08 + rnd() * .5, .07 + rnd() * .4, .06 + rnd() * .34]);
  }

  turntable(B, 0, cy + .045, z0 - .01);

  /* one narrow shelf above, with the sleeves facing out */
  B.add(K.gBox(.22, .045, 1.05), 'shelf', K.place(0, 1.18, R.zEnd + .30, 0, PI / 2, 0));
  for (i = 0; i < 3; i++) {
    B.add(K.gBox(.305, .305, .014), 'sleeve',
          K.place(-.34 + i * .34, 1.365, R.zEnd + .30, 0, (rnd() - .5) * .10, 0),
          [.09 + rnd() * .34, .08 + rnd() * .28, .07 + rnd() * .24]);
  }
}

/* ── the lantern from the photograph ───────────────────────────────────── */
function buildLanterns(B) {
  var zs = [3.0, -1.6, -6.4], shadowAt = 1, i, k;
  for (i = 0; i < zs.length; i++) {
    var z = zs[i], y = R.apex - .12;
    B.add(K.gCyl(.010, .010, .26, 6), 'iron', K.place(0, y - .13, z));
    B.add(K.gCyl(.075, .028, .060, 10), 'iron', K.place(0, y - .29, z));
    B.add(K.gBox(.155, .020, .155), 'iron', K.place(0, y - .50, z));
    for (k = 0; k < 4; k++) {
      B.add(K.gBox(.014, .195, .014), 'iron',
            K.place((k & 1 ? .066 : -.066), y - .40, z + (k & 2 ? .066 : -.066)));
    }
    B.add(K.gBox(.128, .185, .128), 'lampGlass', K.place(0, y - .40, z));
    B.add(K.gCyl(.048, .062, .028, 10), 'iron', K.place(0, y - .315, z));

    var bm = new THREE.MeshBasicMaterial({ color: 0xffd6a0, fog: false });
    bm.color.multiplyScalar(1.75);
    var bulb = new THREE.Mesh(K.gSph(.032, 10), bm);
    bulb.position.set(0, y - .41, z);
    world.add(bulb);
    var sp = new THREE.Sprite(new THREE.SpriteMaterial({
      map: glow, color: 0xffb877, transparent: true, opacity: .55,
      depthWrite: false, blending: THREE.AdditiveBlending, fog: false }));
    sp.position.set(0, y - .41, z);
    sp.scale.setScalar(.95);
    world.add(sp);

    var pl = new THREE.PointLight(C.lamp, 4.6, 9.5, 2);
    pl.position.set(0, y - .41, z);
    if (i === shadowAt) {
      pl.castShadow = true;
      pl.shadow.mapSize.set(1024, 1024);
      pl.shadow.camera.near = .12; pl.shadow.camera.far = 12;
      pl.shadow.bias = -0.004;
    }
    world.add(pl);
    LAMPS.push({ sprite: sp, light: pl, phase: i * 2.3, base: .95, peak: 4.6 });
  }
}

/* ── materials ─────────────────────────────────────────────────────────── */
function buildMaterials() {
  var plaster = K.recipe('plaster', function () { return K.bakePlaster(13, [236, 230, 216]); });
  var pine    = K.recipe('pine',    function () { return K.bakeWood(47, { base: [150, 110, 66], boards: 2 }); });
  var oak     = K.recipe('oak',     function () { return K.bakeWood(83, { base: [138, 100, 62], boards: 0 }); });
  var pale    = K.recipe('pale',    function () { return K.bakeWood(101, { base: [196, 164, 118], boards: 0 }); });
  var weave   = K.recipe('weave',   function () { return K.bakeFabric(59, {}); });
  var burlap  = K.recipe('burlap',  function () {
    return K.bakeFabric(67, { stencil: 'MATKARTELLET', sub: '· 25 KG ·' }); });

  /* The vault is the room's reflector, so it stays bright and matt. Anything
     glossy here would show the lantern as a hotspot and kill the bounce. */
  M.plaster = K.mat(K.tiled(plaster, 3, 6), { roughness: 1, normalScale: .85, color: 0xece6d8 });
  M.floor   = K.mat(K.tiled(bakeTerracotta(21), 3.2, 9), { roughness: .62, normalScale: 1.0 });
  M.shelf   = K.mat(K.tiled(pine, 1, 6), { roughness: .82, normalScale: .8, color: 0xc9b79c });
  M.oak     = K.mat(K.tiled(oak, 1, 1), { roughness: .82, normalScale: .7 });
  M.oakPale = K.mat(K.tiled(pale, 1, 2), { roughness: .70, normalScale: .5 });
  M.wicker  = K.mat(K.tiled(weave, 3, 3), { roughness: .96, normalScale: 1.0, color: 0xc9a978 });
  M.sackcloth = K.mat(K.tiled(burlap, 1.4, 1.4), { roughness: 1, normalScale: .9 });
  M.mat     = K.mat(K.tiled(weave, 8, 12), { roughness: .98, normalScale: .8, color: 0xa88358 });

  M.label   = new THREE.MeshStandardMaterial({
    map: K.recipe('label', function () {
      return K.bakeLabel(5, [190, 166, 122],
        { brand: 'MATKARTELLET', words: ['SYLTET', 'RØKT', 'PRESSET', 'TØRKET', 'SALTET'] });
    }), roughness: .84 });
  M.glass   = new THREE.MeshStandardMaterial({ vertexColors: true, roughness: .10,
                transparent: true, opacity: .62, side: THREE.DoubleSide });
  M.crystal = new THREE.MeshStandardMaterial({ color: 0xe4ecec, roughness: .05,
                transparent: true, opacity: .30, side: THREE.DoubleSide });
  M.lampGlass = new THREE.MeshStandardMaterial({ color: 0xffe0b0, roughness: .12,
                transparent: true, opacity: .26, side: THREE.DoubleSide,
                emissive: 0xff9c4a, emissiveIntensity: .55 });
  M.lid     = new THREE.MeshStandardMaterial({ color: 0xb8ac97, roughness: .42, metalness: .74 });
  M.foil    = new THREE.MeshStandardMaterial({ color: 0x8e2c22, roughness: .55, metalness: .3 });
  M.alu     = new THREE.MeshStandardMaterial({ color: 0xc4c2bc, roughness: .28, metalness: .88 });
  M.iron    = new THREE.MeshStandardMaterial({ color: 0x201c18, roughness: .52, metalness: .62 });
  M.graphite= new THREE.MeshStandardMaterial({ color: 0x22201e, roughness: .60, metalness: .12 });
  M.fabric  = new THREE.MeshStandardMaterial({ color: 0x171615, roughness: .99 });
  M.cabinet = new THREE.MeshStandardMaterial({ color: 0x1c1a19, roughness: .78, metalness: 0 });
  M.vinyl   = new THREE.MeshStandardMaterial({ color: 0x131211, roughness: .30 });
  M.sleeve  = new THREE.MeshStandardMaterial({ vertexColors: true, roughness: .92 });
  M.produce = new THREE.MeshStandardMaterial({ vertexColors: true, roughness: .56 });
  M.meat    = new THREE.MeshStandardMaterial({ vertexColors: true, roughness: .66 });
  M.stem    = new THREE.MeshStandardMaterial({ color: 0x5e6236, roughness: .86 });
  /* the onion net: a warm translucent skin over the pile, which is all a mesh
     sack amounts to from two metres away */
  M.net     = new THREE.MeshStandardMaterial({ vertexColors: true, roughness: .80,
                transparent: true, opacity: .34, side: THREE.DoubleSide });
}

/* ── the scene ─────────────────────────────────────────────────────────── */
function buildScene() {
  scene = new THREE.Scene();
  scene.background = new THREE.Color(C.ink);
  /* light haze only: a white vault does not want to be smoked out */
  scene.fog = new THREE.FogExp2(0x17110c, K.qn('fog', cfg('fog', .0135)));
  world = new THREE.Group(); scene.add(world);
  camera = new THREE.PerspectiveCamera(45, vpW() / vpH(), .12, 90); scene.add(camera);

  /* Higher than a brick cellar would take, because lime plaster bounces: most
     of the light in the reference photo is second-hand, off the vault. */
  scene.add(new THREE.HemisphereLight(C.sky, C.ground, .22));

  /* the accent on the listening end — the room's one piece of staging */
  var acc = new THREE.SpotLight(C.accent, 11, 8.5, .80, .88, 1.7);
  acc.position.set(2.05, R.apex - .40, R.zEnd + 3.4);
  acc.target.position.set(-.70, 1.15, R.zEnd - .2);
  scene.add(acc.target);
  acc.castShadow = true;
  acc.shadow.mapSize.set(1536, 1536);
  acc.shadow.camera.near = .5; acc.shadow.camera.far = 9;
  acc.shadow.bias = -0.0016; acc.shadow.normalBias = .022;
  scene.add(acc);
  /* and one close warm point so the platter and the arm have a highlight of
     their own; a turntable is legible by its specular, not by its silhouette */
  /* Keep this one tight to the deck. Reached any further it front-lights the
     speakers while their own shadows darken the wall behind them, which is
     exactly backwards: pale cabinets against a dark wall. */
  var deck = new THREE.PointLight(0xffc08a, 1.15, 1.35, 2);
  deck.position.set(.06, .95, R.zEnd + 1.05);
  scene.add(deck);
}

function buildWorld() {
  var B = new K.Batch();
  buildShell(B);
  buildShelves(B);
  dressShelves(B);
  hifiWall(B);
  buildLanterns(B);
  var built = B.build(M, world);
  built.forEach(function (m) {
    m.castShadow = true; m.receiveShadow = true;
    if (m.material === M.glass || m.material === M.crystal ||
        m.material === M.net || m.material === M.lampGlass) {
      m.renderOrder = 3; m.castShadow = false;
    }
  });

  dust = K.dust(K.REDUCE ? 700 : 1800, function (i, r) {
    var b = .20 + r() * .34;
    return { x: (r() - .5) * R.halfW * 2, y: .25 + r() * (R.apex - .5),
             z: R.zEnd + r() * (R.zFrontShelf + 3 - R.zEnd),
             r: b, g: b * .82, b: b * .58, size: .011 + r() * .018 };
  }, glow, vpH());
  world.add(dust);
}

/* ── the loop ──────────────────────────────────────────────────────────── */
function onResize() {
  if (!renderer) { page.measure(); return; }
  renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 2) * renderer.userData.quality);
  renderer.setSize(vpW(), vpH(), false);
  camera.aspect = vpW() / vpH(); camera.updateProjectionMatrix();
  composer.setSize(vpW(), vpH());
  if (dust) dust.material.uniforms.uPix.value = vpH() * .5;
  page.measure();
}
function frame(now) {
  requestAnimationFrame(frame);
  var dt = Math.min(.05, (now - lastT) / 1000 || .016); lastT = now; elapsed += dt;
  var prog = page.progress();
  page.setActive(K.clamp(Math.round(prog), 0, page.sections.length - 1));
  if (!ready) return;
  rig.step(prog, page.pointer, dt);
  rig.apply(camera, vpW() / vpH());
  dust.material.uniforms.uTime.value = elapsed;
  for (var i = 0; i < LAMPS.length; i++) {
    var L = LAMPS[i];
    var f = .95 + Math.sin(elapsed * 1.4 + L.phase) * .035 + Math.sin(elapsed * 4.6 + L.phase * 2.1) * .018;
    L.sprite.scale.setScalar(L.base * f);
    L.sprite.material.opacity = .55 * f;
    L.light.intensity = L.peak * f;
  }
  composer.render(scene, camera);
}

page = K.page(ROOT);
addEventListener('resize', onResize, { passive: true });
lastT = performance.now(); requestAnimationFrame(frame);
if (cfg('enabled', true) === false) page.fail('scene disabled in theme settings');
else if (!page.hasWebGL()) page.fail('no webgl');
else (async function () {
  var next = function () { return new Promise(function (r) {
    requestAnimationFrame(function () { setTimeout(r, 0); }); }); };
  try {
    page.setProgress(.06);
    renderer = K.createRenderer(ROOT.querySelector('.cs-gl'),
                                { width: vpW(), height: vpH(), clear: C.ink });
    await next();
    page.setProgress(.20); buildScene(); glow = K.bakeGlow(1, .38); await next();
    page.setProgress(.40); buildMaterials(); await next();
    page.setProgress(.72); buildWorld(); await next();
    page.setProgress(.90);
    rig = K.Rig(CAM, { introDolly: 2.4, parallax: .45 });
    try {
      composer = K.Composer(renderer, {
        exposure: cfg('exposure', .86), bloom: cfg('bloom', .30), threshold: 1.04,
        grade: [1.05, .99, .90], gradeMix: .5, lift: .0035 });
    } catch (e) { composer = K.composerFallback(renderer, e); }
    onResize(); rig.apply(camera, vpW() / vpH());
    renderer.shadowMap.needsUpdate = true;
    composer.render(scene, camera);
    renderer.shadowMap.needsUpdate = false;
    ready = true; page.setProgress(1); await next(); page.ready();
  } catch (err) { page.fail(err && err.message); }
})();

})();